/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2024-05-12 14:45:23
 * @LastEditTime: 2024-05-12 14:47:42
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import 'vant/lib/index.css';

import { Button } from 'vant';

Vue.use(Button);

// toast
import { Toast } from 'vant';

Vue.use(Toast);
// Loading
import { Loading } from 'vant';

Vue.use(Loading);

import { Overlay } from 'vant';

Vue.use(Overlay);

import { Popup } from 'vant';

Vue.use(Popup);

import { Picker } from 'vant';

Vue.use(Picker);

// tabbar 切换
import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar);
Vue.use(TabbarItem);

// 文件上传
import { Uploader } from 'vant';
Vue.use(Uploader);

// 单元格
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);

// latout
import { Col, Row } from 'vant';

Vue.use(Col);
Vue.use(Row)

// icon
import { Icon } from 'vant';

Vue.use(Icon);

Vue.prototype.$dialog = {
    toast: Toast
};
